import React from "react";
import { useTranslation } from "react-i18next";
import { Camera, Subscription } from "../../../../contracts/nexar-api/types";
import CameraListItem from "./camera-list-item/camera-list-item";
import styles from "./my-cameras.module.scss";
import logicToRenderText from "./logic-to-render-text";

const cameraPlaceholderArray = [
  {
    name: "placeholder",
    serialNumber: "Serial Number: placeholder1",
    id: "",
  },
];

interface Props {
  subscriptions: Subscription[] | null;
}

export function MyCameras(props: Props) {
  const { subscriptions } = props;
  const devices = subscriptions
    ?.flatMap((sub) => sub.associatedDevices)
    .filter((device) => !!device) as Camera[];
  const { t } = useTranslation();

  function renderEmpty() {
    return (
      <React.Fragment>
        <p data-testid={"mycameras-empty"}>
          {t("numberNotAssignedToN1CameraError")}
        </p>
      </React.Fragment>
    );
  }
  function renderNormally() {
    const itemsToRender =
      typeof devices === "undefined" ? cameraPlaceholderArray : devices;
    return (
      <div className={styles.ListWrapper}>
        {itemsToRender?.map((item) => {
          const description = logicToRenderText(item, subscriptions, t);
          return (
            <CameraListItem
              key={item.id}
              title={item.serialNumber}
              isPlaceholder={!devices}
              description={description}
            />
          );
        })}
      </div>
    );
  }

  return (
    <div className={styles.MyCamerasWrapper}>
      <h1 data-testid={"my-cameras-title"}>{t("linkedDashCams")}</h1>
      {devices && devices.length === 0 ? renderEmpty() : renderNormally()}
    </div>
  );
}

export default MyCameras;
